// src/pages/Kontakt.js

import React from 'react';
import { Link } from 'react-router-dom';

const Kontakt = () => {
  return (
    <div style={{ padding: '1rem', maxWidth: '600px', margin: '0 auto' }}>
      <h1>Kontakt</h1>

      <p>
        Ako imate bilo kakvih pitanja ili sugestija, slobodno mi pišite na:
        <br />
        <a href="mailto:nebojsa_pandzic@hotmail.com">nebojsa_pandzic@hotmail.com</a>
      </p>
    </div>
  );
};

export default Kontakt;
